import {
  Home1,
  Flask1,
  Database1,
  CloudArrowDownward,
  Server1,
  Folder2,
  Folder3,
  Envelope2,
  CloudRefreshAnticlockwise,
  Globe3,
  Building,
  Buildings2,
  UserMultiple2,
  Gear2,
  BoxesStacked1,
  FileSearch,
  FileFormatPdf,
  Layout1,
  Layout2,
  ScanDocument,
  Hierarchy2,
  FileSwap,
  Cubes,
  Chat2,
  Calendar,
  UserTie,
  StarCircle,
  Wallet2,
  CreditCard,
  DashboardSquare5,
  FileBarChart,
  Rocket1,
  BoxDownload,
  Bank1,
  Shield1Check,
} from '../components/Common/icons';

/**
 * Single source of truth for the showroom's information architecture.
 * Routes (App.js), the sidebar, breadcrumbs and the Overview catalog are all
 * generated from this file — add a component here and it shows up everywhere.
 *
 * Keep this file free of page imports: pages import the doc template, which
 * imports this file, so referencing pages here creates a circular import.
 * Page components are mapped to paths in ./routes.js.
 *
 * Section → (optional) groups → items. Each item is one documented web component.
 */

export const OVERVIEW_ITEM = {
  title: 'Overview',
  path: '/',
  icon: Home1,
};

export const NAV_SECTIONS = [
  {
    id: 'dataplatform',
    title: 'DataPlatform',
    icon: Database1,
    description: 'Document collection, supplier data, document generation and workflow components.',
    playground: {
      title: 'Test Components',
      path: '/testallcomponents/home',
      route: '/testallcomponents/*',
      icon: Flask1,
    },
    groups: [
      {
        id: 'collector',
        title: 'Collector Services',
        icon: CloudArrowDownward,
        packageName: '@oneplatform/collector-services-wc-standalone',
        description: 'Ingest documents from FTP, email, APIs and the web.',
        items: [
          {
            title: 'FTP Server',
            path: '/collector/ftp-server',
            icon: Server1,
            tag: 'ftp-server',
            description: 'Manage FTP server users, permissions and incoming file processing.',
          },
          {
            title: 'FTP Collector',
            path: '/collector/ftp-collector',
            icon: Folder2,
            tag: 'ftp-collector',
            description: 'Configure remote FTP sites to poll, with path filters and health checks.',
          },
          {
            title: 'Email Collector',
            path: '/collector/email-collector',
            icon: Envelope2,
            tag: 'email-collector',
            description: 'Collect attachments from mailboxes using recipient and sender rules.',
          },
          {
            title: 'API Scanner',
            path: '/collector/api-scanner',
            icon: CloudRefreshAnticlockwise,
            tag: 'api-scanner',
            description: 'Poll HTTP endpoints for new files with auth, query parameters and schedules.',
          },
          {
            title: 'Scraper Service',
            path: '/collector/scraper-service',
            icon: Globe3,
            tag: 'scraper-service',
            description: 'Configure and monitor scrapers that collect documents from websites.',
          },
        ],
      },
      {
        id: 'supplier',
        title: 'Supplier Services',
        icon: Building,
        packageName: '@oneplatform/supplier-services-wc-standalone',
        description: 'Supplier, union and product configuration management.',
        items: [
          {
            title: 'Supplier Dashboard',
            path: '/supplier/supplier-dashboard',
            icon: Buildings2,
            tag: 'supplier-dashboard',
            description: 'Create and maintain suppliers with VAT validation and GLN support.',
          },
          {
            title: 'Union Dashboard',
            path: '/supplier/union-dashboard',
            icon: UserMultiple2,
            tag: 'union-dashboard',
            description: 'Manage unions with fiscal IDs and multi-country support.',
          },
          {
            title: 'Config Options Designer',
            path: '/supplier/config-options-designer',
            icon: Gear2,
            tag: 'config-options-designer',
            description: 'Design the configurable fields available per product.',
          },
          {
            title: 'Product Configurations',
            path: '/supplier/product-configurations',
            icon: BoxesStacked1,
            tag: 'product-configurations',
            description: 'Edit per-supplier values for each product configuration field.',
          },
          {
            title: 'Audit Files',
            path: '/supplier/audit-files',
            icon: FileSearch,
            tag: 'audit-files',
            description: 'Browse discount import audit reports produced by the Job Engine.',
          },
        ],
      },
      {
        id: 'document-builder',
        title: 'Document Builder',
        icon: FileFormatPdf,
        packageName: '@oneplatform/document-builder-wc-standalone',
        description: 'Generate, store, template and parse business documents.',
        items: [
          {
            title: 'PDF Generator',
            path: '/document-builder/pdf-generator',
            icon: FileFormatPdf,
            tag: 'pdf-generator-dashboard',
            description: 'Generate PDFs from templates and JSpec documents.',
          },
          {
            title: 'PDF Storage',
            path: '/document-builder/pdf-storage',
            icon: Folder3,
            tag: 'pdf-storage-dashboard',
            description: 'Search, filter and download stored PDF documents.',
          },
          {
            title: 'Template Builder',
            path: '/document-builder/template-builder',
            icon: Layout1,
            tag: 'template-builder-dashboard',
            description: 'Create and edit document templates for PDF generation.',
          },
          {
            title: 'Document Parser',
            path: '/document-builder/document-parser',
            icon: ScanDocument,
            tag: 'document-parser-dashboard',
            description: 'Upload PDFs and extract structured data with AI-powered parsing.',
          },
        ],
      },
      {
        id: 'flow',
        title: 'Document Flow Services',
        icon: Hierarchy2,
        packageName: '@oneplatform/document-flow-services-wc-standalone',
        description: 'Business process flows for documents.',
        items: [
          {
            title: 'Flow Dashboard',
            path: '/flow/flow-dashboard',
            icon: Hierarchy2,
            tag: 'flow-dashboard',
            description: 'Create, monitor and run document workflows.',
          },
        ],
      },
      {
        id: 'document-format-converter',
        title: 'Document Format Converter',
        icon: FileSwap,
        packageName: '@oneplatform/document-format-converter-wc-standalone',
        description: 'Convert between JSpec, EDIFACT and PEPPOL.',
        items: [
          {
            title: 'Document Converter',
            path: '/document-format-converter/document-format-converter-dashboard',
            icon: FileSwap,
            tag: 'document-converter',
            description: 'Convert documents between formats with validation and history.',
          },
        ],
      },
    ],
  },
  {
    id: 'onecore',
    title: 'OneCore',
    icon: Cubes,
    description: 'Customer-facing widgets for communication, booking, CRM and NPS.',
    playground: {
      title: 'Test Components',
      path: '/testonecorecomponents/home',
      route: '/testonecorecomponents/*',
      icon: Flask1,
    },
    groups: [
      {
        id: 'onecore-widgets',
        title: 'Widgets',
        icon: Cubes,
        items: [
          {
            title: 'Communication Widget',
            path: '/onecore/communication-component',
            icon: Chat2,
            tag: 'op-communication-widget',
            description: 'Communication management for OneCore services.',
          },
          {
            title: 'Booking Widget',
            path: '/onecore/booking-component',
            icon: Calendar,
            tag: 'booking-widget',
            description: 'Appointment scheduling for OneCore services.',
          },
          {
            title: 'CRM Widget',
            path: '/onecore/crm-component',
            icon: UserTie,
            tag: 'crm-insights-widget',
            description: 'CRM activities and settings management.',
          },
          {
            title: 'NPS Widget',
            path: '/onecore/nps-component',
            icon: StarCircle,
            tag: 'nps-dashboard-widget',
            description: 'Net Promoter Score surveys and dashboards.',
          },
        ],
      },
    ],
  },
  {
    id: 'financial',
    title: 'Financial Services',
    icon: Wallet2,
    description: 'Aceve Pay payments, onboarding and Open Banking components.',
    playground: {
      title: 'Test Components',
      path: '/testfinancialcomponents/home',
      route: '/testfinancialcomponents/*',
      icon: Flask1,
    },
    groups: [
      {
        id: 'payments',
        title: 'Payments',
        icon: CreditCard,
        items: [
          {
            title: 'Payment Widget',
            path: '/financial/payment-widget',
            icon: CreditCard,
            tag: 'payment-widget',
            description: 'Main payment processing component.',
          },
          {
            title: 'Payments Dashboard',
            path: '/financial/payments-dashboard',
            icon: DashboardSquare5,
            tag: 'payments-dashboard',
            description: 'View and manage payment transactions.',
          },
          {
            title: 'Aceve Pay Usage Dashboard',
            path: '/financial/usage-dashboard',
            icon: FileBarChart,
            tag: 'aceve-pay-usage-dashboard',
            description: 'Usage analytics for Aceve Pay.',
          },
          {
            title: 'Aceve Pay Settings',
            path: '/financial/aceve-pay-settings',
            icon: Gear2,
            tag: 'aceve-pay-settings',
            description: 'Configure Aceve Pay for a tenant.',
          },
        ],
      },
      {
        id: 'onboarding',
        title: 'Onboarding',
        icon: Rocket1,
        items: [
          {
            title: 'Onboarding Dashboard',
            path: '/financial/onboarding-dashboard',
            icon: Rocket1,
            tag: 'onboarding-dashboard',
            description: 'Guide users through payment service setup.',
          },
          {
            title: 'Payment Landing',
            path: '/financial/payment-landing',
            icon: Layout2,
            tag: 'payment-landing',
            description: 'Landing page for onboarding users to payments.',
          },
          {
            title: 'Payment Install Modal',
            path: '/financial/payment-install-modal',
            icon: BoxDownload,
            tag: 'payment-install-modal',
            description: 'Installation modal for the payment service.',
          },
        ],
      },
      {
        id: 'open-banking',
        title: 'Open Banking',
        icon: Bank1,
        items: [
          {
            title: 'Bank Connect',
            path: '/financial/bank-connect',
            icon: Bank1,
            tag: 'bank-connect',
            description: 'Connect a bank account through Open Banking.',
          },
          {
            title: 'BankID Flow',
            path: '/financial/bank-id-flow',
            icon: Shield1Check,
            tag: 'bank-id-flow',
            description: 'BankID authentication for secure user verification.',
          },
        ],
      },
    ],
  },
];

/** Flat list of every documented component, with its section and group attached. */
export const ALL_ITEMS = NAV_SECTIONS.flatMap((section) =>
  section.groups.flatMap((group) => group.items.map((item) => ({ ...item, section, group })))
);

/**
 * Every route the app serves. `pageKey` is the nav path used to look up the
 * lazy page in ./routes.js; `path` is the router pattern.
 */
export const ALL_ROUTES = [
  { path: OVERVIEW_ITEM.path, pageKey: OVERVIEW_ITEM.path },
  ...NAV_SECTIONS.filter((s) => s.playground).map((s) => ({
    path: s.playground.route,
    pageKey: s.playground.path,
    withTestConfig: true,
  })),
  ...ALL_ITEMS.map((item) => ({ path: item.path, pageKey: item.path })),
];

const matchesPath = (pathname, path) => pathname === path || pathname.startsWith(`${path}/`);

/**
 * Resolves the breadcrumb trail for a pathname: [section, group?, page].
 * Returns an empty array for the overview and unknown routes.
 */
export function findBreadcrumbs(pathname) {
  for (const section of NAV_SECTIONS) {
    const { playground } = section;
    if (playground && pathname.startsWith(playground.route.replace('/*', ''))) {
      return [{ title: section.title }, { title: playground.title, path: playground.path }];
    }
    for (const group of section.groups) {
      const item = group.items.find((i) => matchesPath(pathname, i.path));
      if (item) {
        return [{ title: section.title }, { title: group.title }, { title: item.title, path: item.path }];
      }
    }
  }
  return [];
}

export { matchesPath };
